// PACKAGES
import React, { useState } from "react";
import { connect } from "react-redux";
import Axios from "axios-https-proxy-fix";

// FILES
import "./NSuploader.scss";
import translator from "../../utils/translator";
import api from "../../utils/api";
import {
    displayError,
    displaySuccess,
    displayLoading
} from "../../utils/toastHelper";

function UserFileUploader(props) {
    const {
        isNonStock,
        projectId,
        recordId,
        vendorImage,
        vendorSpec,
        userImage,
        userSpec,
        updateImage,
        updateSpec,
    } = props;

    const [localImage, setLocalImage] = useState({ file: "", name: ""});
    const [localSpec, setLocalSpec] = useState({ file: "", name: ""});

    const defaultImage = process.env.REACT_APP_PHP_API + "/images/LG_NotFound.jpg";
    const userFileURLs = isNonStock
        ? {
            image: process.env.REACT_APP_PHP_API + "/images/_nonstock-images/",
            spec: process.env.REACT_APP_PHP_API + "/images/_nonstock-specs/",
        }
        : {
            image: process.env.REACT_APP_PHP_API + "/images/_user-product-images/",
            spec: process.env.REACT_APP_PHP_API + "/images/_user-product-specs/",
        }
    ;
    const fullUserImage = userImage ? userFileURLs.image + userImage : "";
    const fullUserSpec = userSpec ? userFileURLs.spec + userSpec : "";

    const displayImage = localImage.file || fullUserImage || vendorImage || defaultImage;
    const displaySpec = localSpec.file || fullUserSpec || vendorSpec || "";

    const isValidImage = (file) => {
        const fileTypes = [
            "image/jpeg",
            "image/png",
            "image/gif",
        ];
        if (file && fileTypes.includes(file.type)) return true;
        displayError(translator("Misc", "nonstock_image_formats"));
    };

    const isValidSpec = (file) => {
        const fileTypes = ["application/pdf"];
        if (file && fileTypes.includes(file.type)) return true;
        displayError(translator("Misc", "nonstock_spec_formats"));
    };

    const uploadFile = async (type, file, updateFile) => {
        const endLoading = displayLoading(translator("Misc", "uploading_label"));
        const route = isNonStock ? "/uploader/upload-ns-file" : "/uploader/upload-user-file";
        const field = isNonStock ? "non_stock_" + type :  "user_" + type;
        const uploadData = await api.post(
            route,
            {
                project_id: projectId,
                product_id: recordId,
                field,
                file,
                trendId: localStorage.getItem("trendId"),
                token: localStorage.getItem("token"),
            }
        );
        if (uploadData?.success) {
            updateFile(uploadData.success);
            endLoading();
            displaySuccess(translator("Misc", "update_success"));
        } else {
            endLoading();
            displayError(uploadData.error, "Error uploading file");
        }
    };

    const cancelFile = (setFile) => setFile({ file: "", name: ""});

    const selectFile = (event, setFile, isValidFile) => {
        const reader = new FileReader();
        const file = event.target.files[0];

        if (isValidFile(file)) {
            reader.onloadend = () => {
                setFile({
                    file: reader.result,
                    name: file.name
                });
            }
            reader.readAsDataURL(file);
        }
    };

    const deleteFile = async (type, updateFile) => {
        const endLoading = displayLoading(
            translator("Admin Edit Product Group", "deleting_label")
        );
        const route = isNonStock ? "/uploader/remove-ns-file" : "/uploader/remove-user-file";
        const field = isNonStock ? "non_stock_" + type :  "user_" + type;
        const removalData = await api.post(
            route,
            {
                product_id: recordId,
                field,
                trendId: localStorage.getItem("trendId"),
                token: localStorage.getItem("token"),
            }
        );
        if (removalData?.success) {
            updateFile("");
            endLoading();
            displaySuccess(
                translator("Admin Edit Product Group", "product_group_delete_success")
            );
        } else {
            endLoading();
            displayError(removalData.error, "Error deleting file");
        }
    };
    
    return (
        <div className={"nsuploader"}>
            <div className={"nsuploader-section"}>
                <div class="nsuploader-preview">
                    <img src={displayImage} alt="" />
                </div>
                {localImage.file && (
                        <div className={"nsuploader-imagename"}>
                        {localImage.name}
                    </div>
                )}
                <div className={"nsuploader-button-wrapper"}>
                    {localImage.file
                        ? (
                            <>
                                <button
                                    className={"nsuploader-button green"}
                                    onClick={() => uploadFile("image", localImage.file, updateImage)}
                                >
                                    {translator("Admin Edit Floorplan", "upload_btn")}
                                </button>
                                <button
                                    className={"nsuploader-button red"}
                                    onClick={() => cancelFile(setLocalImage)}
                                >
                                    {translator("Misc", "cancel_btn")}
                                </button>
                            </>
                        ) : (
                            <>
                                <label className={"nsuploader-button green"}>
                                    <input 
                                        type="file"
                                        onChange={(event) => selectFile(event, setLocalImage, isValidImage)}
                                    />
                                    {translator("Admin Consultant Settings", "choose_file_label")}
                                </label>
                                <button
                                    className={"nsuploader-button red"}
                                    onClick={() => deleteFile("image", updateImage)}
                                >
                                    {translator("Misc", "delete_label")}
                                </button>
                            </>
                        )
                    }
                </div>
            </div>
            <div className={"nsuploader-section"}>
                <div class="nsuploader-preview-spec">
                    {displaySpec
                        ? (
                            <a
                                className={"link"}
                                target="_blank"
                                rel="noopener noreferrer"
                                href={displaySpec}
                            >
                                {translator("Misc", "current_document_label")}
                            </a>
                            
                        ) : (
                            <div
                                className={"link link-disabled"}
                            >
                                {translator("Misc", "missing_document_label")}
                            </div>
                        )
                    }
                </div>
                <div className={"nsuploader-button-wrapper"}>
                    {localSpec.file
                        ? (
                            <>
                                <button
                                    className={"nsuploader-button green"}
                                    onClick={() => uploadFile("spec", localSpec.file, updateSpec)}
                                >
                                    {translator("Admin Edit Floorplan", "upload_btn")}
                                </button>
                                <button
                                    className={"nsuploader-button red"}
                                    onClick={() => cancelFile(setLocalSpec)}
                                >
                                    {translator("Misc", "cancel_btn")}
                                </button>
                            </>
                        ) : (
                            <>
                                <label className={"nsuploader-button green"}>
                                    <input 
                                        type="file"
                                        onChange={(event) => selectFile(event, setLocalSpec, isValidSpec)}
                                    />
                                    {translator("Admin Consultant Settings", "choose_file_label")}
                                </label>
                                <button
                                    className={"nsuploader-button red"}
                                    onClick={() => deleteFile("spec", updateSpec)}
                                >
                                    {translator("Misc", "delete_label")}
                                </button>
                            </>
                        )
                    }
                </div>
            </div>
        </div>
    );
}


const mapStateToProps = () => {};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(UserFileUploader);
